import { Authenticator } from "@aws-amplify/ui-react";
import App from "./App";

import { I18n } from 'aws-amplify/utils';
import { translations } from '@aws-amplify/ui-react';
import { CustomComponents } from "./components/custom-amplify/CustomComponents";
import { Route, Routes, useLocation } from "react-router-dom";
import InvQuoteView from "./InvQuote/InvQuoteView";
import { StyledEngineProvider } from "@mui/material";
import LlmChatView from "./llm/LlmChatView";
import PartDeliveryPage from "./part-delivery/PartDeliveryPage";
import PublicEmploymentJobsPage from "./flexible-employment/PublicEmploymentJobsPage";
import EmploymentJobDetailsPage from "./flexible-employment/EmploymentJobDetailsPage";
import ContactUsPage from "./contact-us/ContactUsPage";
import AboutUsPage from "./home/AboutUsPage";
import MobileHomePage from "./home/MobileHomePage";
import PricingPage from "./pricing/PricingPage";
I18n.putVocabularies(translations);
I18n.setLanguage('en');

I18n.putVocabulariesForLanguage('en', {
    'Create Account': 'Join', // Tab header
    'Create a new account': 'New User', // Header text
    'Confirm Password': 'Confirm your password', // Confirm Password label
    'Email': 'Enter your email',
    'Phone Number': 'Enter your phone number',
  });
export default function RootView() {
    const location = useLocation();
    const authMode = new URLSearchParams(location.search).get('auth');
    const initialAuthState = authMode === 'signUp' ? 'signUp' : 'signIn';

    return (
      <div>
         <StyledEngineProvider injectFirst>
        <Routes>
          <Route path="/" element={<MobileHomePage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/about-us" element={<AboutUsPage />} />
          <Route path="/contact-us" element={<ContactUsPage />} />
          <Route path="/viewiq" element={<InvQuoteView token={''}/>} />
          <Route path="/part-delivery" element={<PartDeliveryPage />} />
          <Route path="/home" element={<MobileHomePage />} />
          <Route path="/jobs" element={<PublicEmploymentJobsPage />} />
          <Route path="/employment-jobs/:jobId" element={<EmploymentJobDetailsPage />} />

        <Route path="/llmchatview" element={<LlmChatView type="s" />} />
        {/* Authenticated routes grouped */}
        <Route path="/*" element={
          <Authenticator key={`${initialAuthState}`} components={CustomComponents} initialState={initialAuthState}>
          {({ signOut, user }) => (
            <App signOut={signOut} user={user}/>
          )}
        </Authenticator>
        } />
          </Routes>
      
          </StyledEngineProvider>
          </div>
    );
  }